{
  "AddBuilders": "Add Builders",
  "NoBuilders": "No More Builders to select",
  "cancel": "Cancel",
  "Builders": "Builders",
  "GroupMembers": "Group Members",
  "DueDate": "Due Date",
  "NoBuildersAdded": "No builders added yet",
  "optional": " (Optional)",
  "saveSchedule": "Save Schedule",
  "SavedSuccessfully": "saved successfully.",
  "MissingDates": "Enter due_time for the missing dates",
  "GroupNameAlreadyTaken": "Group name has already been taken!",
  "addedSuccessfully": " added successfully.",
  "Managers": "Managers ",
  "Members": "Members ",
  "GroupNameRequired": "Group name is required",
  "CreateGroup": "Create a Group",
  "GroupName": "Group Name ",
  "AddManagersToGroup": "ADD MANAGERS TO GROUP",
  "AddMembersToGroup": "ADD MEMBERS TO GROUP",
  "NameOfGroup": "Name of Group *",
  "AddIntoGroup": "Add into Group",
  "Selected": "Selected",
  "hub": "hub",
  "AllHub": "All Hub",
  "events": "Events",
  "groups": "Groups",
  "CreateGroupPhrase1": "Want to add someone who is not part of your hub?",
  "InviteThem": "Invite them.",
  "CreateGroupPhrase2": "To add someone who is not part of your hub, you must be a",
  "HubAdmin": "hub admin",
  "manager": "Manager",
  "managers": "managers",
  "managedBy": "Managed by",
  "unassigned": "Unassigned",
  "none": "none",
  "empty": "empty",
  "open": "Open",
  "group": "Group",
  "MoreInfo": "More info.",
  "CreateGroupPhrase3part1": "To add a manager who is not part of your hub,",
  "CreateGroupPhrase3part2": "add them to the hub first.",
  "CreateGroupPhrase3part3": "ask a hub admin to add them to the hub first.",
  "createGroup": "create group",
  "addManagers": "add managers",
  "addMembers": "add members",
  "InviteMembersTo": "Invite Members to",
  "deletedSuccessfully": "deleted successfully.",
  "EditGroup": "Edit Group",
  "Manager": "Managers",
  "Member": "Members",
  "searchFor": "search for",
  "removeSelected": "remove selected",
  "select": "select",
  "ConfirmRemovingMember": "Are you sure you want to remove member from the group?",
  "RemovingMemberConsequence1": "All their information will be removed including their project if they are only team member in this group",
  "RemovingMemberConsequence2": " They will not be removed from the hub",
  "Remove": "Remove",
  "member": " Member",
  "AddProject": "+ add project",
  "CreateBuilderSchedule": "Create Builder Schedule",
  "ManageBuilderSchedule": "Manage Builder Schedule",
  "BuilderSchedule": "Builder Schedule",
  "setSchedule": "set schedule",
  "seeAllBuilders": "see all builders",
  "GroupBuilderPhrase1": "You haven't set a schedule.",
  "GroupBuilderPhrase2": "Control which builders your members see here.",
  "GroupBuilderPhrase3": "No Schedule Added",
  "Next": "Next",
  "Upcoming": "Upcoming",
  "Past": "Past",
  "deactivate": "Deactivate",
  "delete": "Delete",
  "activate": "activate",
  "active": "active",
  "inactive": "inactive",
  "Projects": "Projects",
  "EmptyProjectDescription": "No description yet...",
  "ConfirmGroupDeactivation": "Are you sure you want to deactivate this group?",
  "GroupDeactivationConsequence": "All abilities to edit the group will be disabled.",
  "ConfirmDeletingGroup": "Are you sure you want to delete this group?",
  "DeletingGroupConsequence": "This will delete the group for all members and admins.",
  "InactiveSubscription": "This Hub Subscription is Inactive",
  "InactiveSubscriptionMessage": "Your access to the hub will be limited. If you feel this is a mistake, contact them to renew.",
  "ok": "Ok",
  "SubscriptionExpired": "Your Subscription has Expired",
  "SubscriptionExpiredMessage": "Your access to hub is now limited. Please renew by contacting us.",
  "ContactUs": "Contact Us",
  "YouAre": "You are",
  "NoResultFound": "No results found",
  "NoMembersYet": "There are no members here yet.",
  "NoProjectsAvailable": "There are no projects to show here",
  "searchProjects": "search projects",
  "seeMoreProjects": "see more projects",
  "ProjectName": "project name",
  "SearchProjectByName": "Search Projects By Name",
  "changeLogo": "change logo",
  "EditMyRole": "Edit my role(s)",
  "InviteMembers": "Invite members",
  "hideHeader": "hide header",
  "showHeader": "show header",
  "Activity": "Activity",
  "manageTemplateHeader": "You have an unsaved schedule",
  "manageTemplateMessage": "Opening this template will delete the unsaved schedule. Continue?",
  "Templates": "Templates",
  "YourCustomTemplates": "Your Custom Templates",
  "ChooseFromTemplates": "Choose From Templates",
  "confirm": "Confirm",
  "viewBuilder": "view builder",
  "SingleProjectPhrase1": "No builders scheduled yet",
  "Progress": "Progress",
  "Overall": "Overall",
  "switchProject": "switch project",
  "TemplatesPhrase1": "Currently selected: ",
  "No": "No",
  "TemplatesPhrase2": "Templates Found",
  "deleteTemplateButton": "delete template",
  "buildScheduleButton": "build your own schedule",
  "openTemplateButton": "open template",
  "searchForMember": "search for member in ",
  "selectAll": "select all",
  "unselectAll": "unselect all",
  "ExpandAll": "Expand All",
  "CollapseAll": "Collapse All",
  "UploadProject": "Upload Project",
  "Error": "Oops. Something went wrong.",
  "HubGroupSinglePhrase1": "How is progress being tracked?",
  "Completed": "Completed:",
  "HubGroupSinglePhrase2": "This builder is published to",
  "HubGroupsEvents": "Hub, Groups, Events",
  "Everyone": "Everyone",
  "HubGroupSinglePhrase3": "Note: This icon will still appear even if some answers are skipped.",
  "InProgress": "In Progress:",
  "HubGroupSinglePhrase4": "An answer has been saved but the builder has not been published to this group yet.",
  "NotStarted": "Not Started:",
  "HubGroupSinglePhrase5": "No answers have been saved.",
  "NoDueDate": "No Due Date"
}